var React = require('react');

function Folders (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M640 112v224a48 48 0 0 1-48 48H176a48 48 0 0 1-48-48V48a48 48 0 0 1 48-48h160l64 64h192a48 48 0 0 1 48 48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M48 512a48 48 0 0 1-48-48V176a48 48 0 0 1 48-48h48v208a80.09 80.09 0 0 0 80 80h336v48a48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

Folders.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Folders;

Folders.default = Folders;
